<div class="playlist-create-btn" *ngIf="authChannelId == paramsChannelId">
    <app-create-playlist-btn></app-create-playlist-btn>
</div>
<ng-container *ngIf="(dataSourcePlayListState$ | async) as state">
    <div class="video-group">
        <div *ngFor="let playList of state.playLists"
           >
            <div class="video-group-list">
                <div class="video-group-list-cover" [routerLink]="['/channels/channel-playlist/1/playList',playList.id]">
                    <img class="images-cover-create c1"
                         *ngIf="playList?.videos[0]"
                         [src]="playList?.videos[0]?.thumbnail|getImgPath:'images'"
                         alt="">

                    <img class="images-cover-create c1"
                         *ngIf="!playList?.videos[0]"
                         src="assets/img/playList.png"
                         alt="">
                </div>
                <div class="hover-shadow">
                    <button mat-button [matMenuTriggerFor]="menu">
                        <span class="material-symbols-outlined">
                            more_vert
                        </span>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="openConfirmDialog(+playList.id)">
                            <span class="material-symbols-outlined">
                                folder_delete
                            </span>
                            <span>
                                Remove
                            </span>
                        </button>
                    </mat-menu>
                </div>
                <p class="playlist-name">Playlist {{playList.name}}</p>
            </div>
        </div>
    </div>
</ng-container>

